import { FC } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import GameCard from "../GameCard";

type VerticalLayoutProps = {
  gameIds: string[];
  isStacked?: boolean;
  isNewlyGenerated?: boolean;
};

const VerticalLayout: FC<VerticalLayoutProps> = ({
  gameIds,
  isStacked,
  isNewlyGenerated,
}) => {
  const firstRow = gameIds?.slice(0, 10) || [];
  const secondRow = gameIds?.slice(10, 20) || [];

  return (
    <FlexColumn gap={2}>
      <SpaceBetweenCenter gap={2}>
        {firstRow.map((gameId, index) => (
          <GameCard
            key={gameId}
            gameId={gameId}
            imageWidth="86px"
            imageHeight="118px"
            maxWidth="86px"
            index={index}
            isNewlyGenerated={isNewlyGenerated}
          />
        ))}
      </SpaceBetweenCenter>

      {isStacked && (
        <SpaceBetweenCenter gap={2}>
          {secondRow.map((gameId, index) => (
            <GameCard
              key={gameId}
              gameId={gameId}
              imageWidth="86px"
              imageHeight="118px"
              maxWidth="86px"
              index={index + 10}
              isNewlyGenerated={isNewlyGenerated}
            />
          ))}
        </SpaceBetweenCenter>
      )}
    </FlexColumn>
  );
};

export default VerticalLayout;
